//functional imports
import React, { useState } from 'react';
// const parse = require('html-react-parser');
// React-boostrap componets import
import { Jumbotron, Toast, Container, Button, Row, Col, Image, Modal } from 'react-bootstrap';
//custom componets

//main css
//static files


//css modules
import style from "./css/card.module.css"





const Card = ({titleText, noteText, iconUrl, bgUrl, children}) => {
    return (

        <Col>
            <div style={{ marginBottom:'30px', width: "229px", height: "243px", borderRadius: "6px", backgroundImage: `url(${bgUrl})`, backgroundRepeat: "no-repeat", backgroundSize: "cover" }}>
                <Image src={iconUrl} className={style.cardIcon} />
                <div className={style.cardTextDiv}>
                    <p className={style.cardTitle}>{titleText}</p>
                    <p className={style.cardNote}>{noteText}</p>
                </div>
                
            </div>

        </Col>

    );
}

export default Card;



